import React, { useEffect, useState } from "react";
import { Card, Select, Button, Radio, Typography, message,Grid } from "antd";
import { ArrowLeftOutlined, CheckCircleOutlined } from "@ant-design/icons";
import {
  capitalizeWords,
  filterByNonGpProductId,
} from "../Common/CommonFunction";
import "./BookingForm.css";
const { Title, Text } = Typography;
const { Option } = Select;
let tempData = [
  {
    value: "15 minutes",
    text: "RECOMMENDED same day appointments for discussing your single medical concern with our expert GPs.",
  },
  {
    value: "30 minutes",
    text: "IDEAL for discussing more than one medical concern, Mental Health Concerns and/or completing bloods tests.",
  },
  {
    value: "45 minutes",
    text: "SUITABLE for discussing multiple medical concerns, and/or conducting multiple tests like blood tests and ECGs.",
  },
  {
    value: "60 minutes",
    text: "PERFECT for discussing complex or multiple medical concerns, and for second opinions with our expert GPs.",
  },
];

const BookingForm = (props) => {
  // console.log(":props BookingForm:::", props);
  const [selectedDuration, setSelectedDuration] = useState({
    duration: null,
    gender: "no_preference",
    language: { label: "English", value: "1" },
  });
  const [isHovered, setIsHovered] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
     window.scrollTo(0, 0);
  }, []);
  
    const { useBreakpoint } = Grid;
      const screens = useBreakpoint();
  const appointmentForm = (type) => {
    // console.log("SelectedDuration:::", selectedDuration);
    // return
    if (
      props?.showAppoinmentData?.clinic?.productCategory
        ?.product_category_id === 1
    ) {
      if (
        selectedDuration &&
        selectedDuration.duration &&
        selectedDuration.language &&
        selectedDuration.gender
      ) {
        let passPayload = selectedDuration;
        passPayload.type = type;
        // return
        props.callbackBookingForm(passPayload, type);
      } else {
        if (!selectedDuration.language) {
          messageApi.error({
            type: "error",
            content: "Language selection requied.",
          });
        } else if (!selectedDuration.gender) {
          messageApi.error({
            type: "error",
            content: "Gender selection required.",
          });
        } else if (!selectedDuration.duration) {
          messageApi.error({
            type: "error",
            content: "Appointment duration is required.",
          });
        }
      }
    } else {
      props.callbackBookingForm(
        {
          non_gp_product_id:
            props?.showAppoinmentData?.clinic?.non_gp_product_id ?? null,
        },
        type
      );
    }
  };

  return (
    <div className="mainDiv" style={{marginBottom:"30px"}}>
      {contextHolder}
      <div
        style={{
          maxWidth: 605,
          backgroundColor: "rgb(204 236 236)",
          padding: 10,
          marginBottom: 20,
          marginTop:screens.md?"30px":"0px"
        }}
      >
        <Title style={{ margin: 0, fontSize: 20, color: "#008385",
          // fontFamily:"Lato",
          fontWeight:"400" }} className="textalign">
          {/* {capitalizeWords("My booking")}: */}
          My booking:
        </Title>
      </div>

      <div
        className="summuryCard"
        style={{ borderColor: "#008385", maxWidth: 393,minWidth:300,marginInline:10, height: 53,margin:"auto" }}
      >
        {props?.showAppoinmentData &&
        props?.showAppoinmentData.clinic &&
        props?.showAppoinmentData.clinic?.productCategory &&
        props?.showAppoinmentData.clinic?.productCategory?.title
          ? props?.showAppoinmentData.clinic?.productCategory?.title
          : "General GP consultation"}
        <br />
        {props?.showAppoinmentData &&
        props?.showAppoinmentData.clinic &&
        props?.showAppoinmentData.clinic?.productCategory &&
        props?.showAppoinmentData.clinic?.productCategory
          ?.product_category_id == 2 &&
        props?.showAppoinmentData.clinic.non_gp_product_id &&
        props.getAllHealthScreenData &&
        props.getAllHealthScreenData.getAllHealthScreenData.data
          ? filterByNonGpProductId(
              props.getAllHealthScreenData.getAllHealthScreenData.data,
              props?.showAppoinmentData.clinic.non_gp_product_id
            )?.length &&
            filterByNonGpProductId(
              props.getAllHealthScreenData.getAllHealthScreenData.data,
              props?.showAppoinmentData.clinic.non_gp_product_id
            )[0].name
          : ""}
      </div>
      {props?.showAppoinmentData?.clinic?.productCategory
        ?.product_category_id == 1 && (
        <>
            {!screens.md &&  <div style={{textAlign:"left",marginTop:"20px",height:"17px",paddingLeft:"5%"}}> Confirm the following options:</div>}
          <div
            style={{
              maxWidth: "605px",
              backgroundColor: "rgb(204 236 236) ",
              padding: 10,
              marginTop:screens.md? 40: 15,
              marginBottom: 0,
            }}
          >
            <Title style={{ margin: 0, fontSize: 20, color: "#008385",fontFamily:"Lato",fontWeight:"400" }} className="textalign">
              {/* {capitalizeWords("Appointment duration")}: */}
              Appointment duration
            </Title>
          </div>
          <Radio.Group
            onChange={(e) =>
              setSelectedDuration((previousData) => ({
                ...previousData,
                duration: e.target.value,
              }))
            }
          >
            <div style={{ display: "flex", flexDirection: "column",maxWidth:"620px",paddingBottom:"50px",backgroundColor:"#F0FAFA" }}>
              {/* { && props tempData.map((item) => ( */}
              {props &&
                props.data &&
                props.data.durationObjectById &&
                Object.values(props.data.durationObjectById).map((item) => (
                  <div
                    style={{ maxWidth: "100%", textAlign: "left",backgroundColor:"#F0FAFA",paddingLeft:"8vw",paddingTop:"20px" }}
                  >
                    <Radio
                      className="round-checkbox "
                      key={item.duration_id}
                      value={item.duration_id}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <strong style={{color:"#4A4A4A",fontFamily:"Lato",fontWeight:"400"}}>{item.duration} minutes</strong>
                    </Radio>
                    <p className="html-content" 
                      dangerouslySetInnerHTML={{ __html: item.content }}
                      style={{
                        margin: 0,
                        paddingLeft: 28,
                        fontSize: 12,
                        color: "#555",
                        textAlign: "left",
                        paddingRight:"20px",
                        // fontFamily:"Lato",
                      }}
                    />
                  </div>
                ))}
            </div>
          </Radio.Group>

          {/* here changes creating */}
          <div className="preferedLocation">
            <div className="titleBooking titleHeading">
              Preferred language:
              {/* <Title
                className="titleHeading"
                // style={{ margin: 0, fontSize: 20, color: '#008385' }}
              > */}
                {/* {capitalizeWords("Preferred languag")}e: */}
              {/* </Title> */}
            </div>
            <Select
              value={selectedDuration.language} //
              onChange={(lan) =>
                setSelectedDuration((previousData) => ({
                  ...previousData,
                  language: lan,
                }))
              }
              placeholder="Select language"
              style={{ width: 161 }}
              className="dropDown customDropdown"
            >
              {props &&
                props.data &&
                props.data.languageData &&
                props.data.languageData.map((item) => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              {/* <Option value="English">English</Option> */}
            </Select>
          </div>

            <div className="preferedLocation" style={{marginTop:screens.md? 40:20}}>
            
          <div className="titleBooking titleHeading"
            style={{
              background: "rgb(204 236 236)",
            }}
          >
            Preferred gender:
            {/* <Title className="titleHeading"
             style={{ margin: 0, fontSize: 20, color: "#008385" }}
             >
              {capitalizeWords("Preferred gende")}r:
            </Title> */}
          </div>
          <Select
            value={selectedDuration.gender} //
            onChange={(gen) =>
              setSelectedDuration((previousData) => ({
                ...previousData,
                gender: gen,
              }))
            }
            placeholder="Select Gender"
            style={{ width: 161 }}
          className="dropDown customDropdown"          >
            <Option value="no_preference">No preference</Option>
            <Option value="male">Male</Option>
            <Option value="female">Female</Option>
          </Select>
          </div>
        </>
      )}
      <div className="bookingPreference" style={{backgroundColor:"rgb(204 236 236)", marginTop:screens.md? 40:20}}
      >
        Booking preference:
        {/* <Title style={{ margin: 0, color: "#008385" }}>
          {capitalizeWords("Booking preference")}:
        </Title> */}
      </div>

      <div className="bottem" style={{padding:"0px"}}
        // style={{
        //   display: "flex",
        //   justifyContent: "center",
        //   gap: 10,
        //   marginTop: 40,
        // }}
      >
        <div style={{display:"flex",justifyContent:"left",position:screens.md?"absolute":"",left:"0px",marginBottom:"10px",
          // fontFamily:"Lato"
          }} className="widthSetel">
        <Button
          shape="square"
          icon={
            <ArrowLeftOutlined style={{ color: "#008385", fontSize: "18px" }} />
          }
          style={{
            backgroundColor: "#C8E6E6", // Light teal
            border: "none",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
            marginLeft: 10,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
          onClick={() => props.callBackForbackpage("APPOINMENT")}
        />
        </div>
        <div className="bottomButtons">
        <Button
          // type="primary"
          className="transparentBtn customBookingButton"
          style={{ borderColor: "#008385", width: 182, height: 60 }}
          // onMouseEnter={() => setIsHovered(1)}
          // onMouseLeave={() => setIsHovered(0)}
          onClick={() => appointmentForm("PreferredTimeclinic")}
        >
          <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
          {/* <span> {capitalizeWords("Book at")}</span>
          <span>{capitalizeWords("preferred clinic")}</span> */}
          <span> Book at</span>
          <span>preferred clinic</span>
          </div>
        </Button>
        <Button
          // type="primary"
          className="transparentBtn customBookingButton"
          style={{ borderColor: "#008385", width: 182, height: 60 }}
          // onMouseEnter={() => setIsHovered(2)}
          // onMouseLeave={() => setIsHovered(0)}
          onClick={() => appointmentForm("PreferredTime")}
        >
          <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
          {/* <span> {capitalizeWords("Book at")}</span>
          <span>{capitalizeWords("preferred time")}</span> */}
          <span> Book at</span>
          <span>preferred time</span>
          </div>
        </Button>
        </div>
      </div>
    </div>
  );
};

export default BookingForm;
